module.exports = __webpack_public_path__ + "static/media/zhekaWithScheme.e985357b.png";